import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2a6b4a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-info-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    class: "wrap",
    src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/default_avatar.png",
    alt: "avatar"
  })
], -1))
const _hoisted_3 = {
  class: "user-content",
  style: {"flex":"1"}
}
const _hoisted_4 = { class: "user-content-name" }
const _hoisted_5 = { class: "name-text" }
const _hoisted_6 = { class: "name-btn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  class: "wrap",
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_edit.png",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_8 = { class: "user-content-member" }
const _hoisted_9 = {
  key: 0,
  class: "not-opened-vip"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"6px","font-size":"18px"}
}, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"6px"}
}, null, -1))
const _hoisted_13 = { class: "flex-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/warning.svg" }, null, -1))
const _hoisted_15 = { style: {"margin-left":"4px"} }
const _hoisted_16 = { class: "flex-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"6px"}
}, null, -1))

import AppLink from '@/components/common/AppLink.vue'
import { useStore } from 'vuex'
import { ref, computed, Ref, onMounted } from 'vue'
import { automaticToggle, getAutomaticToggleStaus, getPrecharegeOrderApi, isFirstPayVipApi } from '@/apis/usercenter'
import { t } from '@/plugins/i18n'
import { useRtfix, isD2C, isJA } from '@/store'
import ADialog from '@/views/usercenter/VipLevel/ADialog.vue'
import BDialog from '@/views/usercenter/VipLevel/BDialog.vue'
import AutoPayDisabled from '@/views/usercenter/VipLevel/components/AutoPayDisabled.vue'
import { ElMessage } from 'element-plus'
import { mapLevelSign } from './data'
import { ENUM_RENEWAL_STATUS, ENUM_RENEWAL_STYLE } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { CustomerMembershipResDTO } from '@/apis/interface/customer'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const user = computed(() => store.getters.user)

/** 是否为子账号 */
const isSub: boolean = store.getters.isSub
/** 会员信息 */
const membership: CustomerMembershipResDTO = store.getters.membership
/** 是否开通过会员 */
const isFirstVip = ref(false)
/** 自动续费开启状态 */
const isAuto: Ref<ENUM_RENEWAL_STATUS> = ref(ENUM_RENEWAL_STATUS.CLOSE)
/** 自动续费开启方式 */
const isPayType: Ref<ENUM_RENEWAL_STYLE> = ref(ENUM_RENEWAL_STYLE.BALANCE)
/** 自动续费开启弹窗 */
const AutoVisible = ref(false)
/** 是否预充会员 */
const beforehandVipInfo = ref()
/** 是否为Paypal */
const isPaypal = computed(() => {
  return isPayType.value === ENUM_RENEWAL_STYLE.Paypal
})

/** 异常处理详情 */
const aDialogVisible = ref(false)
const autoPayDisabledVisible = ref(false)

/** 获取用户是否自动续费状态 */
const getAutomaticStaus = async () => {
  const res = await getAutomaticToggleStaus({
    superCustomerId: membership.superCustomerId
  })
  isAuto.value = Number(res.data?.automaticRenewalStatus) as ENUM_RENEWAL_STATUS
  isPayType.value = res.data?.automaticRenewalStytle as ENUM_RENEWAL_STYLE
}

/** 刷新 */
const reload = () => location.reload()

/** 关闭自动续费 */
const closeAuto = async () => {
  const res = await automaticToggle({
    automaticRenewalStatus: ENUM_RENEWAL_STATUS.CLOSE,
    automaticRenewalStytle: ENUM_RENEWAL_STYLE.Paypal
  })
  if (res.success) {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: 'off_auto_renewal'
      }
    })
    ElMessage.success(t('关闭成功'))
    getAutomaticStaus()
  }
}
/** 开启自动续费 */
const openAutoVisible = async () => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改'))
    return
  }
  if (beforehandVipInfo.value.oldExpiresDate) {
    // 如果是预充会员提示不允许自动续费
    autoPayDisabledVisible.value = true
    return
  }

  const res = await automaticToggle({
    automaticRenewalStatus: ENUM_RENEWAL_STATUS.OPEN,
    automaticRenewalStytle: ENUM_RENEWAL_STYLE.BALANCE // 开启续费永远是余额续费
  })
  if (res.success) {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: 'on_auto_renewal'
      }
    })
    aDialogVisible.value = true
  }
}

// 判断数字如果没有就返回0
const judgeNumFields = (val: any) => {
  if (val) {
    return val
  } else {
    return ' - '
  }
}

/** 是否预充会员 */
const getPrecharegeStatus = async () => {
  const res = await getPrecharegeOrderApi({
    superCustomerIds: store.getters.membership?.superCustomerId
  })
  beforehandVipInfo.value = res.data[0] || {}
}

/** 是否第一次充值会员 */
const getFirstVip = async () => {
  const res = await isFirstPayVipApi({})
  // false：未开通会员
  if (!res.data) {
    isFirstVip.value = true
  }
}

onMounted(() => {
  getPrecharegeStatus()
  getFirstVip()
  getAutomaticStaus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["user-info", _unref(isD2C)() ? 'd2c' : 'b2b'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(user)?.loginName), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AppLink, {
                to: _unref(useRtfix)('setupUser'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _unref(taTrack)({
                event: _unref(TaEvent).BTN_CLICK,
                value: {
                  position: 'edit_name'
                }
              })
              ))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AppLink, {
              to: _unref(useRtfix)('VipLevel')
            }, {
              default: _withCtx(() => [
                (_unref(membership)?.templateLevel === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(isFirstVip.value ? _unref(t)('未入会') : _unref(t)('已失去会員')), 1),
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["opened-vip", Number(_unref(membership)?.templateLevel) > 0 ? `opened-vip-${_unref(membership)?.templateLevel}` : ''])
                    }, [
                      _createElementVNode("img", {
                        src: _unref(mapLevelSign).get(_unref(membership)?.templateLevel)?.icon,
                        class: "vip-sign",
                        width: "24",
                        height: "20"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", null, _toDisplayString(_unref(membership)?.membershipTemplateName ?? ''), 1)
                    ], 2))
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_unref(membership)?.templateLevel && isAuto.value === _unref(ENUM_RENEWAL_STATUS).CLOSE)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_unref(isSub))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "member-btn",
                      onClick: openAutoVisible
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('会员自动续费')) + ":" + _toDisplayString(isAuto.value === _unref(ENUM_RENEWAL_STATUS).CLOSE ? 'OFF' : 'ON') + " ", 1),
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_unref(user)?.customerMobile)
        ? (_openBlock(), _createBlock(AppLink, {
            key: 0,
            class: "user-info-phone",
            to: _unref(useRtfix)('setupUser'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
      _unref(taTrack)({
        event: _unref(TaEvent).BTN_CLICK,
        value: {
          position: 'edit_phone'
        }
      })
      ))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('请补充手机号信息')), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('立即填写')), 1),
                _hoisted_17
              ])
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(ADialog, {
      visible: aDialogVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((aDialogVisible).value = $event)),
      "is-paypal": _unref(isPaypal),
      membership: _unref(membership),
      onSubmit: closeAuto,
      isAuto: isAuto.value,
      onReload: reload
    }, null, 8, ["visible", "is-paypal", "membership", "isAuto"]),
    _createVNode(BDialog, {
      visible: AutoVisible.value,
      "onUpdate:visible": [
        _cache[3] || (_cache[3] = ($event: any) => ((AutoVisible).value = $event)),
        reload
      ]
    }, null, 8, ["visible"]),
    _createVNode(AutoPayDisabled, {
      visible: autoPayDisabledVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((autoPayDisabledVisible).value = $event)),
      beforehandVipInfo: beforehandVipInfo.value
    }, null, 8, ["visible", "beforehandVipInfo"])
  ], 64))
}
}

})